<div class="faq sec-padding bgm-white">
  <div class="container">
    <div  class="p-0 fx-row xs-fx-col fx-main-center fx-cross-center">
        <div class="questions xs-fx-flex-100-in-col print-fx-flex-100 sm-fx-flex-100 gt-sm-fx-flex-50">
            <div class="faq-wrap">
                <mat-accordion>
                    <mat-expansion-panel>
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                            <span>What is do i have to tell you a few lorem?</span>
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <p>
                          Lorem ipsum dolor sit amet, consectetur adi pisi cing elit, sed do eiusmod tempor exercitationemut labore. Love life’s sweetest reward Let it flow it floats back to you.
                        </p>
                    </mat-expansion-panel>
                    <mat-expansion-panel>
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                              <span>What is do i have to tell you a few lorem?</span>
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                        <p>
                            Lorem ipsum dolor sit amet, consectetur adi pisi cing elit, sed do eiusmod tempor exercitationemut labore. Love life’s sweetest reward Let it flow it floats back to you.
                          </p>
                      </mat-expansion-panel>
                      <mat-expansion-panel>
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                                <span>What is do i have to tell you a few lorem?</span>
                            </mat-panel-title>
                          </mat-expansion-panel-header>
                          <p>
                              Lorem ipsum dolor sit amet, consectetur adi pisi cing elit, sed do eiusmod tempor exercitationemut labore. Love life’s sweetest reward Let it flow it floats back to you.
                            </p>
                        </mat-expansion-panel>
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                              <mat-panel-title>
                                  <span>What is do i have to tell you a few lorem?</span>
                              </mat-panel-title>
                            </mat-expansion-panel-header>
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adi pisi cing elit, sed do eiusmod tempor exercitationemut labore. Love life’s sweetest reward Let it flow it floats back to you.
                              </p>
                          </mat-expansion-panel>
                  </mat-accordion>
            </div>
        </div>

    </div>

  </div>
</div>
